import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxInnerLoadingModule } from 'ngx-inner-loading';

import { ConversationModule } from './conversation/conversation.module';
import { MessageComponent } from './message.component';
import { MessageCellModule } from './message-cell/message-cell.module';

@NgModule({
  declarations: [MessageComponent],
  exports: [MessageComponent],
  imports: [
    CommonModule,
    MessageCellModule,
    ConversationModule,
    NgxInnerLoadingModule,
  ],
})
export class MessageModule {}
